<template>
  <v-card
    :loading="loading"
    height="100%"
    @click="cardClick"
    :class="{
      'icon-pattern': isAd
    }"
  >
    <v-card-title class="pb-0 text-truncate subtitle-1 font-weight-bold">
      <v-img
        :src="type.icon"
        v-if="type.icon"
        max-width="20"
        class="mr-1"
      ></v-img>
      {{ title }}
      <v-tooltip
        v-model="tooltip"
        :open-on-hover="false"
        open-on-click
        top
        color="white"
        max-width="400"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            x-small
            v-bind="attrs"
            v-on="on"
            @click.stop="on.click"
            color="lighttext"
            class="ml-1"
          >
            <v-icon>help</v-icon>
          </v-btn>
        </template>
        <v-container
          class="secondarytext--text elevation-5 rounded-lg px-0 pb-0 overflow-hidden"
        >
          <v-row dense>
            <v-col class="font-weight-bold px-8 pb-0 my-auto">
              {{ title }}
            </v-col>
            <v-spacer class="limited-spacer"> </v-spacer>
            <v-col cols="auto" class="my-auto mr-4 pa-0">
              <v-btn icon @click="tooltip = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col class="px-8 pb-4">
              {{ tooltip_text }}
            </v-col>
          </v-row>
          <v-row class="background">
            <v-col cols="auto" class="my-auto pl-8">
              <v-img
                :src="
                  is_anonymous
                    ? $images.COLLECTION_METHOD_ANONYMOUS
                    : $images.COLLECTION_METHOD
                "
              ></v-img>
            </v-col>
            <v-col>
              <div class="primary--text font-weight-bold subtitle-1 pr-8">
                How is this data collected?
              </div>
              {{ tooltip_collection_text }}
            </v-col>
          </v-row>
        </v-container>
      </v-tooltip>
      <v-spacer></v-spacer>
      <v-btn
        text
        color="info"
        class="pr-0 pl-1"
        v-if="link && settings.isPaidPlan"
      >
        View report
        <v-icon small>
          keyboard_arrow_right
        </v-icon>
      </v-btn>
      <v-btn
        text
        color="info"
        class="pr-0 pl-1"
        v-else-if="!settings.isPaidPlan"
        to="/billing"
      >
        Upgrade
        <v-icon small>
          keyboard_arrow_right
        </v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text
      v-if="coreCard && coreCard.type != $enums.coreCardTypes.HIGH_LOW"
      :class="{
        'pb-0': !isPulse,
        'core-card-body': true,
        'core-card-body--scroll':
          coreCard.type == this.$enums.coreCardTypes.MISSION_VALUE
      }"
    >
      <template v-if="coreCard">
        <template v-if="coreCard.isEmpty">
          <v-row>
            <v-col cols="12">
              <span class="text-h4" style="opacity: 0;">No Data Available</span>
            </v-col>
          </v-row>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-img
                :src="$images.CORE_CARD_NO_DATA"
                height="125"
                contain
                v-bind="attrs"
                v-on="on"
              ></v-img>
            </template>
            <span class="pa-2">
              There is no data to display yet
            </span>
          </v-tooltip>
        </template>
        <template v-else-if="coreCard.excludeFromRanking">
          <v-row>
            <v-col cols="12">
              <span class="text-h4" style="opacity: 0;">Anonymity Limit</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="auto">
              <v-img :src="$images.PULSE_ICON"></v-img>
            </v-col>
            <v-col>
              <div class="subtitle-1 font-weight-medium">Anonymity Limit</div>
              <div>Data is hidden due to segment size</div>
            </v-col>
          </v-row>
        </template>
        <v-row v-else-if="isOverall" class="fill-height">
          <core-card-overall
            v-if="!coreCard.isEmpty"
            :coreCard="coreCard"
          ></core-card-overall>
        </v-row>
        <v-row v-else-if="isENPS" class="fill-height">
          <core-card-enps
            v-if="!coreCard.isEmpty"
            :coreCard="coreCard"
          ></core-card-enps>
        </v-row>
        <template v-else-if="isPulse">
          <core-card-pulse
            v-if="!coreCard.isEmpty"
            :coreCard="coreCard"
          ></core-card-pulse>
        </template>
        <core-card-recognition
          v-else-if="coreCard.type == $enums.coreCardTypes.RECOGNITION"
          :coreCard="coreCard"
        ></core-card-recognition>
        <template v-else>
          <v-row>
            <core-card-score
              :coreCard="coreCard"
              :isPercent="isPercent"
              :showPossible="showPossibleInScore"
              :isPercentComplete="isPercentComplete"
            ></core-card-score>
          </v-row>
          <v-row>
            <core-card-progress
              :coreCard="coreCard"
              v-if="showProgress"
              :showPossible="showPossibleInProgress"
            ></core-card-progress>
            <core-card-trend
              :coreCard="coreCard"
              v-else-if="coreCard.trend"
            ></core-card-trend>
            <core-card-core-values
              :coreCard="coreCard"
              v-else-if="(coreCard.coreValues || []).length > 0"
            ></core-card-core-values>
            <core-card-users
              :coreCard="coreCard"
              v-else-if="(coreCard.users || []).length > 0"
            ></core-card-users>
            <core-card-goals
              :coreCard="coreCard"
              v-else-if="(coreCard.goals || []).length > 0"
            ></core-card-goals>
            <core-card-action-items
              :coreCard="coreCard"
              v-else-if="(coreCard.actionItems || []).length > 0"
            ></core-card-action-items>
            <v-col cols="12" v-else-if="isAd" class="my-auto text-center">
              <v-btn color="performance" to="/billing">
                Upgrade to read
              </v-btn>
            </v-col>
          </v-row>
        </template>
      </template>
    </v-card-text>
    <v-card-text
      class="py-0 core-card-body core-card-body--scroll"
      v-if="
        coreCard && !coreCard.isEmpty && coreCard.items && coreCard.items.length
      "
    >
      <core-card-items
        :coreCard="coreCard"
        :report="type.reportLink"
        :identifier="identifier"
      >
      </core-card-items>
    </v-card-text>
    <core-card-footer
      v-if="!hideFooter"
      :coreCard="coreCard"
      :isPercent="isPercent"
      :round="round"
      :showRank="showRank"
      :alternateText="footerAlternateText"
      :filter="filter"
    ></core-card-footer>
    <upgrade-core-card-dialog
      ref="upgradeDialog"
      :coreCard="coreCard"
      :type="type"
    ></upgrade-core-card-dialog>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import CoreCardFooter from "@/components/corecard/CoreCardFooter";
import CoreCardScore from "@/components/corecard/CoreCardScore";
import CoreCardProgress from "@/components/corecard/CoreCardProgress";
import CoreCardTrend from "@/components/corecard/CoreCardTrend";
import CoreCardCoreValues from "@/components/corecard/CoreCardCoreValues";
import CoreCardUsers from "@/components/corecard/CoreCardUsers";
import CoreCardGoals from "@/components/corecard/CoreCardGoals";
import CoreCardActionItems from "@/components/corecard/CoreCardActionItems";
import CoreCardOverall from "@/components/corecard/CoreCardOverall";
import CoreCardEnps from "@/components/corecard/CoreCardEnps";
import CoreCardPulse from "@/components/corecard/CoreCardPulse";
import CoreCardItems from "@/components/corecard/CoreCardItems";
import UpgradeCoreCardDialog from "@/components/corecard/UpgradeCoreCardDialog";
import CoreCardRecognition from "@/components/corecard/CoreCardRecognition";
export default {
  name: "CoreCard",
  components: {
    CoreCardFooter,
    CoreCardScore,
    CoreCardProgress,
    CoreCardTrend,
    CoreCardCoreValues,
    CoreCardUsers,
    CoreCardGoals,
    CoreCardActionItems,
    CoreCardOverall,
    CoreCardEnps,
    CoreCardItems,
    UpgradeCoreCardDialog,
    CoreCardPulse,
    CoreCardRecognition
  },
  props: {
    type: { type: Object },
    annualReviewId: { type: String, default: null },
    identifier: { type: Object },
    startDate: { type: String },
    name: { type: String },
    includeItems: { type: Boolean, default: false }
  },
  data: () => ({
    loading: false,
    tooltip: false
  }),
  watch: {
    annualReviewId(val, oldVal) {
      if (val != oldVal) {
        this.loadData();
      }
    },
    identifier: {
      handler(val, oldVal) {
        var newType = (val || {}).type;
        var oldType = (oldVal || {}).type;
        var newId = (val || {}).id;
        var oldId = (oldVal || {}).id;
        var newTimeframeId = (val || {}).timeframeId;
        var oldTimeframeId = (oldVal || {}).timeframeId;
        var newCustomStartDate = (val || {}).customStartDate;
        var oldCustomStartDate = (oldVal || {}).customStartDate;
        var newCustomEndDate = (val || {}).customEndDate;
        var oldCustomEndDate = (oldVal || {}).customEndDate;
        if (
          newType != oldType ||
          newId != oldId ||
          newTimeframeId != oldTimeframeId ||
          newCustomStartDate != oldCustomStartDate ||
          newCustomEndDate != oldCustomEndDate
        ) {
          if (
            newTimeframeId != this.$enums.timeframes.CUSTOM ||
            (newCustomEndDate && newCustomStartDate)
          ) {
            this.loadData();
          }
        }
      },
      deep: true
    }
  },
  computed: {
    footerAlternateText() {
      switch (this.type.id) {
        case this.$enums.coreCardTypes.GOAL:
          return "goals";
        case this.$enums.coreCardTypes.ACTION_ITEM:
          return "action items";
        default:
          return "";
      }
    },
    scoreIcon() {
      switch (this.type.id) {
        case this.$enums.coreCardTypes.GOAL:
          return "terrain";
        case this.$enums.coreCardTypes.ACTION_ITEM:
          return "fact_check";
        default:
          return "";
      }
    },
    is_anonymous() {
      switch (this.type.id) {
        case this.$enums.coreCardTypes.MISSION_VALUE:
        case this.$enums.coreCardTypes.TEAM_COHESION:
        case this.$enums.coreCardTypes.STRATEGIC_ANCHORS:
        case this.$enums.coreCardTypes.ENPS:
        case this.$enums.coreCardTypes.PULSE:
        case this.$enums.coreCardTypes.HIGH_LOW:
          return true;
        default:
          return false;
      }
    },
    tooltip_text() {
      switch (this.type.id) {
        case this.$enums.coreCardTypes.REVIEW:
          if (this.identifier.type == this.$enums.coreCardIdTypes.MEMBER) {
            return `The 360 review score for ${this.name} represents how co-workers responded to review questions overtime.`;
          } else {
            return "The 360 review for this group represents how all of the individuals within this segment were scored overtime.";
          }
        case this.$enums.coreCardTypes.IDEAL_TEAM_PLAYER:
          return "[put description here]";
        case this.$enums.coreCardTypes.OVERALL:
          return "Using our proprietary algorithm, the CoreCounts overall score offers you one simple metric for a clear view into how this individual, team, department or company is doing.";
        case this.$enums.coreCardTypes.ENGAGEMENT:
          return "Overall participation represents the task participation rate for this individual, team, department or company. The higher the percentage the more surveys, resources, etc have been completed. This is scored on a 0-100 scale. ";
        case this.$enums.coreCardTypes.RECOGNITION:
          return `Data collected here represents all of the recognition recieved by this individual or individuals. Recognition is categorized by ${this.t(
            "mission.title",
            true
          )} and ${this.t("core_values.title", true)}.`;
        case this.$enums.coreCardTypes.GOAL:
          return "The goal activity report details the goal statuses within this segement. The 4 goal status types are On Track, Off Track, Paused and Complete. This report does not detail the sub-goal status.";
        case this.$enums.coreCardTypes.ACTION_ITEM:
          return `The action item activity report gives you a view into the action item statuses of ${this.name}. The 3 available status types are past due, open and complete.`;
        case this.$enums.coreCardTypes.MISSION_VALUE:
          return `The ${this.t("mission.title", true)} & ${this.t(
            "core_values.title_short_s",
            true
          )} score is the overall average score given for the ${this.t(
            "mission.title",
            true
          )} & ${this.t(
            "core_values.title_short_s",
            true
          )} questions within the culture tracking survey for this specific group of people.`;
        case this.$enums.coreCardTypes.TEAM_COHESION:
        case this.$enums.coreCardTypes.STRATEGIC_ANCHORS:
          return "[put description here]";
        case this.$enums.coreCardTypes.ENPS:
          return "The eNPS Is a standard scoring system designed to help employers measure employee satisfaction and loyalty within their organizations.";
        case this.$enums.coreCardTypes.PULSE:
          return "The culture tracking score is the overall average score given for each question within the culture tracking survey for this specific group of people.";
        case this.$enums.coreCardTypes.MANAGER_SCORE:
          if (this.identifier.type == this.$enums.coreCardIdTypes.COMPANY) {
            return "The manager score uses multiple data points to provide you with a single metric for measuring how all of the managers in your company are performing.";
          }
          return "The manager score uses multiple data points to provide you with a single metric for measuring how this manager is performing as a manager.";
        case this.$enums.coreCardTypes.ANONYMOUS_FEEDBACK:
          return `Anonymous feedback shows the feedback that has been submitted through the culture tracking survey`;
        case this.$enums.coreCardTypes.HIGH_LOW:
          return `Data displayed here represents the categories that score the highest or lowest in culture tracking surveys.`;
        default:
          return "";
      }
    },
    tooltip_collection_text() {
      switch (this.type.id) {
        case this.$enums.coreCardTypes.REVIEW:
          return "Employees & Managers identified response to 360 review questions";
        case this.$enums.coreCardTypes.IDEAL_TEAM_PLAYER:
          return "Employees & Managers identified response to ideal team player questions";
        case this.$enums.coreCardTypes.OVERALL:
          return "Our algorithm uses multiple sources across the CoreCounts platform";
        case this.$enums.coreCardTypes.ENGAGEMENT:
          return "Employees engagement with tasks created in CoreCounts.";
        case this.$enums.coreCardTypes.RECOGNITION:
          return "Collected when employees recognize other employees";
        case this.$enums.coreCardTypes.GOAL:
          return "Employees & Managers progress within their goals";
        case this.$enums.coreCardTypes.ACTION_ITEM:
          return "Employees & Managers progress within their action items";
        case this.$enums.coreCardTypes.MISSION_VALUE:
          return `Employees anonymous reponses to the ${this.t(
            "mission.title",
            true
          )} & ${this.t(
            "core_values.title_short_s",
            true
          )} questions within culture tracking.`;
        case this.$enums.coreCardTypes.TEAM_COHESION:
          return "Employees anonymouse responses to team cohesion questions within culture tracking";
        case this.$enums.coreCardTypes.STRATEGIC_ANCHORS:
          return "Employees anonymouse responses to strategic anchor questions within culture tracking";
        case this.$enums.coreCardTypes.ENPS:
          return "Employees anonymous response to the eNPS question in culture tracking";
        case this.$enums.coreCardTypes.PULSE:
          return "Employees anonymous reponses to the culture tracking survey";
        case this.$enums.coreCardTypes.MANAGER_SCORE:
          return "CoreCounts uses 360 review data & team metrics for this score.";
        case this.$enums.coreCardTypes.ANONYMOUS_FEEDBACK:
          return `Employees anonymous feedback to the culture tracking survey`;
        case this.$enums.coreCardTypes.HIGH_LOW:
          return `Employees’ anonymous responses to the culture tracking survey.`;
        default:
          return "";
      }
    },
    hideFooter() {
      return (
        this.identifier.type == this.$enums.coreCardIdTypes.COMPANY ||
        this.isOverall
      );
    },
    showRank() {
      if (this.identifier.type == this.$enums.coreCardIdTypes.MEMBER) {
        return this.identifier.id != this.profile.id;
      }
      return true;
    },
    title() {
      switch (this.type.id) {
        case this.$enums.coreCardTypes.REVIEW:
          return "360 Review";
        case this.$enums.coreCardTypes.IDEAL_TEAM_PLAYER:
          return "Ideal Team Player";
        case this.$enums.coreCardTypes.OVERALL:
          return `Overall Score: ${this.name}`;
        case this.$enums.coreCardTypes.ENGAGEMENT:
          return "Overall Participation";
        case this.$enums.coreCardTypes.RECOGNITION:
          return "Received Recognition";
        case this.$enums.coreCardTypes.GOAL:
          return "Goal Activity";
        case this.$enums.coreCardTypes.ACTION_ITEM:
          return "Action Item Activity";
        case this.$enums.coreCardTypes.MISSION_VALUE:
          if (this.coreCard) {
            if (this.coreCard.isMission) {
              return `${this.t("mission.title")} Score`;
            }
            if (this.coreCard.coreValue) {
              return `${this.t("core_values.title_short_s")} Score`;
            }
          }
          return `${this.t("mission.title")} & ${this.t(
            "core_values.title_short"
          )}`;
        case this.$enums.coreCardTypes.TEAM_COHESION:
          return "Team Cohesion";
        case this.$enums.coreCardTypes.STRATEGIC_ANCHORS:
          return "Strategic Anchors";
        case this.$enums.coreCardTypes.ENPS:
          return `eNPS`;
        case this.$enums.coreCardTypes.PULSE:
          return `Culture Tracking`;
        case this.$enums.coreCardTypes.MANAGER_SCORE:
          if (this.identifier.type != this.$enums.coreCardIdTypes.MEMBER) {
            return "Managers Score";
          }
          return "Manager Score";
        case this.$enums.coreCardTypes.ANONYMOUS_FEEDBACK:
          return `Anonymous Feedback`;
        case this.$enums.coreCardTypes.HIGH_LOW:
          return `High & Low`;
        default:
          return "";
      }
    },
    showPossibleInScore() {
      switch (this.type.id) {
        case this.$enums.coreCardTypes.REVIEW:
        case this.$enums.coreCardTypes.IDEAL_TEAM_PLAYER:
        case this.$enums.coreCardTypes.MISSION_VALUE:
        case this.$enums.coreCardTypes.TEAM_COHESION:
        case this.$enums.coreCardTypes.STRATEGIC_ANCHORS:
        case this.$enums.coreCardTypes.OVERALL:
        case this.$enums.coreCardTypes.PULSE:
        case this.$enums.coreCardTypes.MANAGER_SCORE:
          return true;
        default:
          return false;
      }
    },
    showPossibleInProgress() {
      switch (this.type.id) {
        default:
          return false;
      }
    },
    showProgress() {
      switch (this.type.id) {
        default:
          return false;
      }
    },
    isPercent() {
      switch (this.type.id) {
        case this.$enums.coreCardTypes.ENGAGEMENT:
          return true;
        default:
          return false;
      }
    },
    isPercentComplete() {
      switch (this.type.id) {
        case this.$enums.coreCardTypes.GOAL:
        case this.$enums.coreCardTypes.ACTION_ITEM:
          return true;
        default:
          return false;
      }
    },
    round() {
      switch (this.type.id) {
        case this.$enums.coreCardTypes.ENPS:
          return true;
        default:
          return false;
      }
    },
    isOverall() {
      return this.type.id == this.$enums.coreCardTypes.OVERALL;
    },
    isENPS() {
      return this.type.id == this.$enums.coreCardTypes.ENPS;
    },
    isPulse() {
      return this.type.id == this.$enums.coreCardTypes.PULSE;
    },
    coreCard() {
      return this.$store.getters["corecard/core_card"](this.type.id);
    },
    filter() {
      return Object.assign(
        {
          type: this.type.id,
          annualReviewId: this.annualReviewId,
          startDate: this.startDate,
          userId:
            this.identifier.type == this.$enums.coreCardIdTypes.MEMBER
              ? this.identifier.id
              : null,
          managerId:
            this.identifier.type == this.$enums.coreCardIdTypes.MANAGER
              ? this.identifier.id
              : null,
          teamId:
            this.identifier.type == this.$enums.coreCardIdTypes.TEAM
              ? this.identifier.id
              : null,
          coreValue:
            this.identifier.type == this.$enums.coreCardIdTypes.CORE_VALUE
              ? this.identifier.id
              : null,
          includeItems: this.includeItems
        },
        {
          timeframeId: this.identifier.timeframeId,
          customStartDate: this.identifier.customStartDate,
          customEndDate: this.identifier.customEndDate,
          customTimezone: this.identifier.customTimezone
        }
      );
    },
    reportFilter() {
      switch (this.identifier.type) {
        case this.$enums.coreCardIdTypes.MEMBER:
          return "members";
        case this.$enums.coreCardIdTypes.MANAGER:
          return "teams";
        case this.$enums.coreCardIdTypes.TEAM:
          return "departments";
        default:
          return "";
      }
    },
    link() {
      if (!this.type.reportLink) {
        return null;
      }
      if (
        this.identifier.type == this.$enums.coreCardIdTypes.COMPANY &&
        !this.is_admin
      ) {
        return null;
      }
      let url = `/reporting/${this.type.reportLink}`;

      if (this.reportFilter) {
        url += `/${this.reportFilter}/${this.identifier.id}`;
      }

      return url;
    },
    isAd() {
      return (
        !this.settings.isPaidPlan &&
        this.type.id == this.$enums.coreCardTypes.ANONYMOUS_FEEDBACK
      );
    },
    ...mapGetters({
      profile: "profile/profile",
      settings: "profile/settings",
      is_admin: "profile/is_admin"
    })
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      this.$store
        .dispatch("corecard/getCoreCard", this.filter)
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading core card."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    showUpgrade() {
      this.$refs.upgradeDialog.showDialog();
    },
    cardClick() {
      if (this.settings.isPaidPlan) {
        if (this.link) {
          this.$router.push({ path: this.link });
        }
      } else {
        this.showUpgrade();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.core-card-body {
  height: 190px;

  &--scroll {
    overflow-y: scroll;
  }
}
</style>
